import React from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { TextMessage } from './components/TextMessage';
import { VideoMessage } from './components/VideoMessage';
import { useSupporterVoices } from './hooks/useSupporterVoices';

export const SupporterVoices: React.FC = () => {
	const {
		data: { shouldShowSupporterVoices, supporterVoices, topicName, totalSupporterVoices },
	} = useSupporterVoices();

	// If there are less than 3 supporter voices, we don't show the section
	if (!shouldShowSupporterVoices) return null;

	return (
		<div className="flex flex-col gap-10">
			<Text as="h2" variant="heading" className="text-typography-strong" data-qa="supporter-voices-heading">
				<Translate
					value="corgi.topic_page.supporter_voices.title.headline"
					replacements={{ count: totalSupporterVoices, topic: topicName }}
				/>
			</Text>

			<div className="b-1 overflow-x-auto md:pb-3">
				<div className="flex gap-6">
					{supporterVoices.map((voice) => {
						if (voice.type === 'text') {
							return <TextMessage supporterVoice={voice} key={voice.id} />;
						}

						return <VideoMessage supporterVoice={voice} key={voice.id} />;
					})}
				</div>
			</div>
		</div>
	);
};
